var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"wrapper"},[_c('span',{staticClass:"inner"},[_c('Icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"size":_vm.iconSize}}),_c('span',{staticClass:"title",style:({ fontSize: _vm.fontSize })},[_vm._v(_vm._s(_vm.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }